import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import useUpdateQueryParams from "@/hooks/use-update-query-params";
import Axios from "@/lib/axios-instance";
import useOnboardingData from "@/store/onboarding-data";

type MetaType = {
    code: number;
    message: string;
};

type UserData = {
    id: string;
    email: string;
    is_paid: boolean;
    // Add other user fields based on the API response
};

type ResponseType = {
    data: UserData;
    meta: MetaType;
};

type ErrorResponse = {
    response?: {
        data?: {
            meta?: {
                code: number;
                message: string;
            };
        };
    };
    message?: string; // Fallback for network errors
};

export const initializeUser = async () => {
    try {
        const response = await Axios.put("/users/initialize-user", {});
        return response.data;
    } catch (err: unknown) {
        const error = err as ErrorResponse;
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useInitializeUser = () => {
    const queryClient = useQueryClient();
    const updateQueryParams = useUpdateQueryParams();
    const { setIsInitialized } = useOnboardingData();
    return useMutation<ResponseType, Error>({
        mutationFn: () => initializeUser(),
        onSuccess: () => {
            setIsInitialized(true);
            queryClient.invalidateQueries({ queryKey: ["check_user"] });
            updateQueryParams({ first_visit: undefined, step: undefined });
            // updateSearchParams({ first_visit: undefined, step: undefined });
            toast.success("Basic Setup Completed");
        },
        onError: (error) => {
            toast.error("Setup completion failed.", { description: error.message });
        },
    });
};
